<template>
  <div class="field">
    <div>
      <mt-cell
        class="mt-cell"
        title="姓名"
        value="魏宏裕"/>
      <mt-cell
        class="mt-cell"
        title="关系"
        value="本人"/>
      <mt-cell
        class="mt-cell"
        title="医院"
        value="汕头市濠江医院"/>
      <mt-cell
        class="mt-cell"
        title="卡号"
        value="001234"/>
      <mt-cell
        class="mt-cell"
        title="持卡人"
        value="魏宏裕"/>
      <mt-cell
        class="mt-cell"
        title="手机号"/>
    </div>
    <div style="margin:0 10px">
      <mt-button
        class="mt-button"
        type="primary"
        size="large">确定</mt-button>
      <mt-button
        class="mt-button"
        type="danger"
        size="large">删除</mt-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManagementMedicalCard',
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped>
  .field {
    margin-top: 14px;
    margin-bottom: 10px;
  }
  .mt-button {
    margin-top: 10px;
  }
  .mt-cell {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/medical-card/management-medical-card.vue